import ConfirmationToken from './ConfirmationToken';
import ForgotPasswordOrCode from './ForgotPasswordOrCode';
import Login from './Login';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import Logout from './Logout';
import ResettingPassword from './ResettingPassword';
import Profile from './Profile';
import ChangePassword from './ChangePassword';
import ChangeCode from './ChangeCode';
import AvatarForm from './AvatarForm';

export  {
  ConfirmationToken,
  ForgotPasswordOrCode,
  Login,
  LoginForm,
  RegisterForm,
  Logout,
  Profile,
  ResettingPassword,
  ChangePassword,
  ChangeCode,
  AvatarForm,
}



// WEBPACK FOOTER //
// ./src/components/security/index.js